module.exports = __webpack_public_path__ + "ddfa531852704d2c28f5b47f29ec8bb8.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/ABCMonumentGroteskSemi-Mono-Regular.woff2
// module id = 36
// module chunks = 0 1